import React from 'react';
import { connect } from 'react-redux';

import Form from './Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import * as userDuck from '../../user/duck';

class Join extends React.Component {
  handleSubmit = ({ status }) => {
    const { project, requestUserDataIfNeeded } = this.props;

    return (
      API.post('users/me/projects/', {
        project: project._id,
        status,
      })
        // Refresh the user
        .then(requestUserDataIfNeeded)
        .catch(catchFormErrors)
    );
  };

  render() {
    return (
      <Form initialValues={{ status: 'ACTIVE' }} onSubmit={this.handleSubmit} />
    );
  }
}

const mapDispatchToProps = {
  requestUserDataIfNeeded: userDuck.requestDataIfNeeded,
};

export default connect(
  null,
  mapDispatchToProps
)(Join);



// WEBPACK FOOTER //
// ./src/projects/join-user/index.js